/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { selectors } from 'State/ToastMessages';
import { ToastMessageTrigger, ToastMessageTriggers } from 'State/ToastMessages/Types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import Navigation from '../../Navigation/Navigation';
import { NavigationLink } from '../../Types/NavigationLink';
import StandardLayoutBody from './StandardLayoutBody/StandardLayoutBody';

interface StandardLayoutProps {
    navigationLinks: NavigationLink[];
    children: React.ReactNode;
}

function StandardLayout({ children, navigationLinks }: StandardLayoutProps): React.ReactElement<StandardLayoutProps> {
    const { listen, push } = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 1000 });

    const toastMessageTriggers: ToastMessageTrigger[] = useSelector(selectors.toastMessageTriggers);

    const [navIsOpen, toggleNavIsOpen] = useState<boolean>(!isMobile);

    const closePanelOnRouteChange = () => {
        toggleNavIsOpen(false);
    };

    // @ts-ignore
    useEffect(() => {
        if (isMobile) {
            const routeListener = listen(closePanelOnRouteChange);

            return routeListener;
        }
    }, [isMobile]);

    const handleNavToggle = (): void => {
        toggleNavIsOpen(!navIsOpen);
    };

    const handleBody = (): void => {
        if (isMobile && navIsOpen) toggleNavIsOpen(false);
    };

    useEffect(() => {
        if (toastMessageTriggers.length) {
            const openConversationTriggers = toastMessageTriggers.filter(
                ({ name }: ToastMessageTrigger) => name === ToastMessageTriggers.OPEN_CONVERSATIONS,
            );

            if (openConversationTriggers.length) push('/conversations');
        }
    }, [toastMessageTriggers]);

    return (
        <>
            <Navigation isOpen={navIsOpen} navigationLinks={navigationLinks} toggleNav={handleNavToggle} />
            <StandardLayoutBody navIsOpen={navIsOpen} handleBodyClick={handleBody}>
                {children}
            </StandardLayoutBody>
        </>
    );
}

export default StandardLayout;
